"use strict";

module.exports = {
    schemeForResult: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/scheme.js
// module id = 54
// module chunks = 1 4